import Vue from 'vue';

export default product => Vue.$http.post('Products', product);



// WEBPACK FOOTER //
// ./src/services/product/create.js